import * as React from 'react'

const PptIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <g id="SVGRepo_iconCarrier">
        <g
          id="Page-1"
          fill="none"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          {...props}
          ref={ref}
        >
          <g id="drop" fill="#000" transform="translate(85.325 42.667)">
            <path
              id="Combined-Shape"
              d="M234.675 0H.01v234.667h42.666v-192H216.97l81.706 81.706v110.294h42.667v-128zM53.717 332.634c-3.498 1.685-9.258 2.538-17.28 2.538H28.14V299.29h8.298c8.022 0 13.888 1.088 17.558 3.328 4.992 3.008 7.488 8.128 7.488 15.296 0 7.274-2.582 12.202-7.766 14.72m10.496-52.63c-6.464-1.621-15.829-2.432-28.117-2.432H0V405.7h28.864v-48.832H40.96c8.81 0 16-.682 21.568-2.026 5.59-1.344 10.325-3.606 14.25-6.742 9.046-7.232 13.569-17.642 13.569-31.19 0-8.32-1.899-15.594-5.718-21.802q-7.04-11.648-20.416-15.104m115.38 52.275c-3.5 1.686-9.26 2.54-17.28 2.54h-8.3v-35.884h8.3c8.02 0 13.888 1.088 17.557 3.328 4.992 3.008 7.488 8.128 7.488 15.296 0 7.275-2.581 12.203-7.765 14.72m10.496-52.629c-6.464-1.621-15.83-2.432-28.118-2.432h-36.096v128.128h28.864v-48.832h12.096c8.81 0 16-.683 21.568-2.027 5.59-1.344 10.326-3.605 14.25-6.74 9.046-7.233 13.569-17.644 13.569-31.19 0-8.32-1.899-15.595-5.717-21.803q-7.042-11.648-20.416-15.104m44.586-2.08v22.613h37.056v105.515h28.864V300.183h37.61V277.57z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
)

PptIcon.displayName = 'PptIcon'

export { PptIcon }
